import React from 'react';
import Box from '@mui/material/Box';
import { useFormik } from 'formik';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import Fluid from 'layouts/Fluid';
import Container from 'components/Container';
import ResizableFrame from 'components/ResizableFrame';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import { Footer } from 'layouts/Main/components';



const Step6Success = () => {

  let isDisabled = true;

  const formik = useFormik({
    initialValues: {agree: false} ,
    onSubmit,
  });

  if (formik.values.agree === true ) {
    isDisabled = false;
  }

  const onSubmit = () => {
  };

// console.log('nnnnnnnnn', defaultChecked)

  return (
    <>
   <Box bgcolor={'alternate.main'}>
       <br />
       <br />
        <Container maxWidth={0.8} paddingY={'0 !important'}>
          <Box>
            <Typography variant={'h4'} fontWeight={700} align={'center'}>
            Thank You
            </Typography>
            <br />
            <br />

            <Typography  fontWeight={250} align={'justify'}>
           You are admitted, your payment is successful.
            </Typography>
            </Box>
            </Container>
            </Box>
          </>
  );
};

export default Step6Success;